import { getElasticSearchUrl } from "../helpers/elasticSettings";

const fetchEventsData = async (
  dateFrom,
  searchTerm = "",
  customerType = "",
  filters = [],
  offset = 0
) => {
  const elasticUrl = await getElasticSearchUrl();

  if (searchTerm) {
    filters.push({
      multi_match: {
        query: searchTerm,
        fields: ["drupalTitle"],
        // fuzziness: "AUTO",
      },
    });
  }

  if (customerType) {
    filters.push({
      nested: {
        path: "drupalCustomerType",
        query: {
          bool: {
            filter: [
              {
                term: {
                  ["drupalCustomerType.id.keyword"]: customerType,
                },
              },
            ],
          },
        },
      },
    });
  }

  try {
    const response = await fetch(elasticUrl + "/_search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic ZWxhc3RpYzplbGFzdGlj",
      },
      body: JSON.stringify({
        query: {
          bool: {
            must: [
              {
                range: {
                  tixStartDate: {
                    gte: dateFrom,
                  },
                },
              },
            ],
            filter: [...filters],
          },
        },
        sort: [
          {
            tixStartDate: {
              order: "asc",
            },
          },
        ],
        size: 10,
        from: offset,
        aggs: {
          drupalCategory: {
            nested: {
              path: "drupalCategory",
            },
            aggs: {
              drupalCategoryId: {
                terms: {
                  field: "drupalCategory.id.keyword",
                  size: 30,
                },
                aggs: {
                  drupalCategoryName: {
                    terms: {
                      field: "drupalCategory.label.keyword",
                      size: 1,
                    },
                  },
                },
              },
            },
          },
          ...buildElasticAggs(),
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Elasticsearch data:", error);
    throw error;
  }
};

const fetchEventDatesData = async (
  dateFrom,
  dateTo,
  searchTerm = "",
  customerType = "",
  filters = []
) => {
  const elasticUrl = await getElasticSearchUrl();

  if (searchTerm) {
    filters.push({
      multi_match: {
        query: searchTerm,
        fields: ["drupalTitle"],
        // fuzziness: "AUTO",
      },
    });
  }

  if (customerType) {
    filters.push({
      nested: {
        path: "drupalCustomerType",
        query: {
          bool: {
            filter: [
              {
                term: {
                  ["drupalCustomerType.id.keyword"]: customerType,
                },
              },
            ],
          },
        },
      },
    });
  }

  try {
    const response = await fetch(elasticUrl + "/_search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic ZWxhc3RpYzplbGFzdGlj",
      },
      body: JSON.stringify({
        _source: ["tixStartDate"],
        query: {
          bool: {
            must: [
              {
                range: {
                  tixStartDate: {
                    gte: dateFrom,
                  },
                },
              },
              {
                range: {
                  tixStartDate: {
                    lte: dateTo,
                  },
                },
              },
            ],
            filter: [...filters],
          },
        },
        sort: [
          {
            tixStartDate: {
              order: "asc",
            },
          },
        ],
        size: 10000,
        aggs: {
          drupalCategory: {
            nested: {
              path: "drupalCategory",
            },
            aggs: {
              drupalCategoryId: {
                terms: {
                  field: "drupalCategory.id.keyword",
                  size: 30,
                },
                aggs: {
                  drupalCategoryName: {
                    terms: {
                      field: "drupalCategory.label.keyword",
                      size: 1,
                    },
                  },
                },
              },
            },
          },
          ...buildElasticAggs(),
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Elasticsearch data:", error);
    throw error;
  }
};

const fetchFavouriteEventsData = async (FavIds = [], offset = 0, size = 10) => {
  const FavIdArray = Object.values(FavIds);
  const elasticUrl = await getElasticSearchUrl();

  try {
    const response = await fetch(elasticUrl + "/_search", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Basic ZWxhc3RpYzplbGFzdGlj",
      },
      body: JSON.stringify({
        query: {
          bool: {
            must: [
              {
                terms: {
                  tixEventId: FavIdArray,
                },
              },
            ],
          },
        },
        sort: [
          {
            tixStartDate: {
              order: "asc",
            },
          },
        ],
        size: size,
        from: offset,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching Elasticsearch data:", error);
    throw error;
  }
};

const buildElasticAggs = () => {
  const aggs = {};
  const aggNames = {
    venue: "tixVenue",
    hall: "tixHall",
    grade: "drupalGrade",
    capacity: "tixCapacity",
    tema: "drupalTema",
  };
  const filterTypes = window.__khstCalendarFilterFilterTypes || [];

  filterTypes.forEach((filter) => {
    const aggName = aggNames[filter];
    let agg = {};

    switch (filter) {
      case "capacity":
        agg = {
          terms: {
            field: aggName + ".keyword",
            size: 100,
          },
        };
        break;

      case "hall":
        agg = {
          nested: {
            path: aggName,
          },
          aggs: {
            [aggName]: {
              terms: {
                field: aggName + ".label.keyword",
                size: 30,
              },
            },
          },
        };
        break;

      default:
        agg.aggs = {
          [aggName + "Id"]: {
            terms: {
              field: aggName + ".id.keyword",
              size: 30,
            },
            aggs: {
              [aggName + "Name"]: {
                terms: {
                  field: aggName + ".label.keyword",
                  size: 1,
                },
              },
            },
          },
        };
        agg.nested = {
          path: aggName,
        };
        break;
    }

    aggs[aggName] = agg;
  });

  return aggs;
};

const buildElasticFilters = (selectedFilters) => {
  const filters = [];

  const filterKeys = Object.keys(selectedFilters);
  filterKeys.forEach((key) => {
    if (selectedFilters[key].length > 0) {
      let filter = {};

      switch (key) {
        case "tixCapacity":
          const value = selectedFilters[key][0];
          if (!value) {
            return;
          }

          const range = selectedFilters[key][0].split("-");
          filter = {
            range: {
              [key]: {
                gte: parseInt(range[0], 10),
                lte: parseInt(range[1], 10),
              },
            },
          };
          break;

        case "tixHall":
          filter = {
            nested: {
              path: key,
              query: {
                bool: {
                  filter: [
                    {
                      terms: {
                        [key + ".label.keyword"]: selectedFilters[key],
                      },
                    },
                  ],
                },
              },
            },
          };
          break;

        default:
          filter = {
            nested: {
              path: key,
              query: {
                bool: {
                  filter: [
                    {
                      terms: {
                        [key + ".id.keyword"]: selectedFilters[key],
                      },
                    },
                  ],
                },
              },
            },
          };
          break;
      }

      filters.push(filter);
    }
  });

  return filters;
};

const getPredefinedVenue = () => {
  const venueMap = {
    sergels_torg: "205",
    skarholmen: "206",
    vallingby: "240",
    husby: "242",
    parkteatern: "268",
  };

  if (window.__khstCalendarFilterPredefinedVenue && Array.isArray(window.__khstCalendarFilterPredefinedVenue)) {
    return window.__khstCalendarFilterPredefinedVenue
      .map(v => venueMap[v] || null)
      .filter(Boolean);
  }

  return null;
};

export {
  fetchEventsData,
  fetchEventDatesData,
  fetchFavouriteEventsData,
  buildElasticAggs,
  buildElasticFilters,
  getPredefinedVenue,
};
